var map = {
	"./bearbnb.JPG": 41,
	"./chingu.jpg": 42,
	"./corporateclone.JPG": 43,
	"./fcc.jpg": 44,
	"./junipermail.jpg": 45,
	"./modmemes.jpg": 46,
	"./momentumclone.JPG": 47,
	"./npm.jpg": 48,
	"./resumeclone.JPG": 49,
	"./thumb-designsteins-2019.png": 50,
	"./thumb-designsteins.png": 51,
	"./thumb-earlycollegevote.png": 52,
	"./thumb-pathutility.png": 53,
	"./thumb-sogal.png": 54,
	"./thumb-togetherwevote.png": 55,
	"./thumb-tuvototuidioma.png": 56,
	"./thumb-vannya-me.png": 57,
	"./turtrello.JPG": 58,
	"./website-bearbnb.png": 59,
	"./website-chingu.png": 60,
	"./website-designsteins-2.png": 61,
	"./website-designsteins-2019.png": 62,
	"./website-designsteins.png": 63,
	"./website-earlycollegevote.png": 64,
	"./website-modmemes.png": 65,
	"./website-pathutility.png": 66,
	"./website-resume.png": 67,
	"./website-sogal.png": 68,
	"./website-togetherwevote.png": 69,
	"./website-tuvototuidioma.png": 70,
	"./website-vannya-me.png": 71,
	"./website-vannya-momentum.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;